export const noop = (..._args: any[]): any => {}; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
